import { jsx as n } from "react/jsx-runtime";
const t = ({
  saveSelectedSimilarProduct: o
}) => /* @__PURE__ */ n("div", { className: "change-order-moda-footer", children: /* @__PURE__ */ n(
  "button",
  {
    onClick: () => o == null ? void 0 : o(),
    className: "change-order-save-buttom",
    children: "Salvar Substituto"
  }
) });
export {
  t as ModalFooter
};
